// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Polyfills

// intersection observer polyfill
// (required by Vue-CLazyload on most browsers for now)
require('intersection-observer')

// Isomorophic Fetch polyfill
require('es6-promise').polyfill()
require('isomorphic-fetch')

// Array.prototype.find() polyfill (required for IE compatibility)
require('array.prototype.find').shim()

// Vue.js
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@/assets/styles/main.scss'
import { sync } from 'vuex-router-sync'

// Vue.js plugins
import VueClazyLoad from 'vue-clazy-load'
import VueAgile from 'vue-agile'

sync(store, router)
Vue.config.productionTip = false
Vue.use(VueClazyLoad)
Vue.use(VueAgile)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js